const auth = store => async (to, from, next) => {
    // prevent timing issues and make sure user data is set
    await store.dispatch("auth/init");

    // We are checking all the matched routes for nested routes
    // (cf. https://router.vuejs.org/api/#route-object-properties)
    //
    if (to.matched.some(record => record.meta.authRequired)) {
        if (!store.getters["auth/isLoggedIn"]) {
            next({
                path: "/auth/login",
                query: { redirect: to.fullPath },
            });
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.guestsOnly)) {
        if (store.getters["auth/isLoggedIn"]) {
            await store.dispatch("auth/checkMsTeams");
            next({ path: "/profile", query: { init: true } });
        } else {
            next();
        }
    } else {
        next();
    }
};

export default auth;
